const PAGE_ENTRY_EVENTS = new Set(['page_view', 'open_page'])

export function createPageContextTracker(initialState = {}) {
  let state = {
    pageTitle: initialState.pageTitle || '',
    prevPageTitle: initialState.prevPageTitle || '',
  }

  const resolve = (payload = {}, documentTitle = '') => {
    const context = resolvePageContext(payload, state, documentTitle)
    state = {
      pageTitle: context.pageTitle,
      prevPageTitle: context.prevPageTitle,
    }
    return context
  }

  return { resolve }
}

export function resolvePageContext(payload = {}, state = {}, documentTitle = '') {
  const currentPageTitle = state.pageTitle || ''
  const currentPrevPageTitle = state.prevPageTitle || ''
  const resolvedTitle = payload.page_title || currentPageTitle || documentTitle

  if (PAGE_ENTRY_EVENTS.has(payload.event)) {
    const nextPageTitle = payload.page_title || documentTitle || currentPageTitle
    const nextPrevPageTitle = currentPageTitle || documentTitle

    return {
      page_title: nextPageTitle,
      prev_page_title: nextPrevPageTitle,
      pageTitle: nextPageTitle,
      prevPageTitle: nextPrevPageTitle,
    }
  }

  if (payload.event === 'close_page') {
    return {
      page_title: resolvedTitle,
      prev_page_title: currentPrevPageTitle,
      pageTitle: '',
      prevPageTitle: resolvedTitle,
    }
  }

  return {
    page_title: resolvedTitle,
    prev_page_title: currentPrevPageTitle,
    pageTitle: currentPageTitle,
    prevPageTitle: currentPrevPageTitle,
  }
}
